import React from "react";
import { useState } from "react";
import Layout from "../Layout";
import { Box, Grid } from "@mui/material";
import ProfileBanner from "../../../shared/ProfileBanner/ProfileBanner";
import ProfileFromAddUser from "../../../widgets/supervisor/add-new-user/ProfileFromAddUser";
import TotalScoreNewUser from "../../../widgets/supervisor/add-new-user/TotalScoreNewUser";
import AvailableCRMNewUser from "../../../widgets/supervisor/add-new-user/AvailableCRMNewUser";
import FunctionalityNewUser from "../../../widgets/supervisor/add-new-user/FunctionalityNewUser";
import NewUserDetailsTable from "../../../widgets/supervisor/add-new-user/NewUserDetailsTable";

function AddNewUser(props) {
  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    password: "",
    telegram: "",
    salary_amount: "",
    salary_date: new Date().toISOString().split("T")[0],
    birthday_date: "",
    phone_number: "",
    date_of_start: new Date().toISOString().split("T")[0],
    role: "operator",
    status: "active",
  });
  return (
    <Layout>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <ProfileFromAddUser form={userData} setForm={setUserData} />
      </Grid>
      {/* <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <NewUserDetailsTable />
      </Grid>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <TotalScoreNewUser />
      </Grid>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <AvailableCRMNewUser />
          <FunctionalityNewUser />
        </Box>
      </Grid> */}
    </Layout>
  );
}

export default AddNewUser;
